import assetPath from '/app/xinglets/lebenslauf/pages/startpage/src/assets/google-play-badge-de.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')